import React from 'react'
import Svg from '../elements/Svg'

export const Jekyll = ({ color = '#333333', ...props }) => (
  <Svg
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    viewBox='0 0 512 512'
    enableBackground='new 0 0 512 512'
    {...props}
  >
    <g id='logo-bg-dark'>
      <rect id='bg' fill={color} width='512' height='512' />
      <g id='test-tube'>
        <path
          id='shadow_2_'
          opacity='0.3'
          d='M269.02,59.151c-0.184,0.737-0.188,1.529-0.033,2.365c0,0,2.507,16.642-0.339,24.048
                        L147.643,400.197l0.009,0.004c-8.636,23.11,2.937,48.911,26.014,57.787c23.077,8.875,48.955-2.524,58.03-25.464l0.011,0.005
                        l121.005-314.634c2.366-6.155,15.86-18.079,15.86-18.079c0.677-0.516,1.202-1.108,1.56-1.778l0.059-0.122
                        c0.065-0.132,0.141-0.258,0.193-0.395c3.12-8.113-17.005-23.405-44.952-34.152c-27.948-10.748-53.133-12.884-56.253-4.771
                        c-0.053,0.137-0.083,0.281-0.122,0.422L269.02,59.151z'
        />

        <linearGradient
          id='tube_3_'
          gradientUnits='userSpaceOnUse'
          x1='206.4585'
          y1='215.2629'
          x2='283.1295'
          y2='291.9339'
          gradientTransform='matrix(0.9138 -0.4062 0.4062 0.9138 -80.6459 125.703)'
        >
          <stop offset='0' style={{ stopColor: '#919191' }} />
          <stop offset='1' style={{ stopColor: '#FFFFFF' }} />
        </linearGradient>
        <path
          id='tube_2_'
          fill='url(#tube_3_)'
          d='M265.523,56.477c-0.185,0.737-0.19,1.529-0.033,2.365c0,0,2.508,16.642-0.34,24.048
                        L144.144,397.522l0.011,0.004c-8.635,23.11,2.937,48.911,26.014,57.787c23.075,8.875,48.955-2.524,58.03-25.464l0.011,0.005
                        L349.215,115.22c2.365-6.155,15.86-18.079,15.86-18.079c0.677-0.516,1.202-1.107,1.56-1.778l0.058-0.122
                        c0.065-0.131,0.141-0.258,0.193-0.395c3.12-8.113-17.005-23.404-44.951-34.152c-27.948-10.748-53.133-12.884-56.253-4.771
                        c-0.053,0.137-0.083,0.281-0.122,0.422L265.523,56.477z'
        />

        <linearGradient
          id='liquid_2_'
          gradientUnits='userSpaceOnUse'
          x1='177.6289'
          y1='273.7523'
          x2='224.0456'
          y2='320.1689'
          gradientTransform='matrix(0.9138 -0.4062 0.4062 0.9138 -80.6459 125.703)'
        >
          <stop offset='0' style={{ stopColor: '#990000' }} />
          <stop offset='1' style={{ stopColor: '#E80000' }} />
        </linearGradient>
        <path
          id='liquid'
          fill='url(#liquid_2_)'
          d='M303.48,198.814L216.218,425.71l0.057,0.021
                        c-6.436,16.262-25.166,24.723-41.781,18.333c-16.615-6.39-25.608-25.512-19.488-41.897l0,0l55.758-144.982
                        c0,0,6.964-11.233,20.637-19.225c13.673-7.991,24.949-6.305,40.132-13.053C286.715,218.159,303.48,198.814,303.48,198.814z'
        />

        <ellipse
          id='top'
          transform='matrix(0.9334 0.359 -0.359 0.9334 48.4129 -108.3439)'
          fill={color}
          cx='315.97'
          cy='76.201'
          rx='33.648'
          ry='8.85'
        />
        <path
          id='side-reflection'
          opacity='0.3'
          fill='#FFFFFF'
          d='M265.489,58.841c0,0,2.471,16.737-0.34,24.048L144.144,397.522
                        l0.011,0.004c-8.635,23.11,2.937,48.911,26.014,57.787c4.005,1.54,8.092,2.455,12.164,2.822
                        c-15.556-11.702-22.23-32.632-15.093-51.73l-0.011-0.004L285.833,98.009C285.833,98.009,269.689,82.85,265.489,58.841z'
        />
        <g id='bubbles'>
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='226.531'
            cy='261.806'
            r='3.506'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='249.514'
            cy='287.227'
            r='5.285'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='214.429'
            cy='317.459'
            r='9.915'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='198.375'
            cy='335.795'
            r='5.286'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='219.43'
            cy='375.008'
            r='3.506'
          />
        </g>
      </g>
    </g>
    <g id='logo-bg-light' display='none'>
      <g id='test-tube_1_' display='inline'>
        <path
          id='shadow_1_'
          opacity='0.1'
          d='M269.02,59.151c-0.184,0.737-0.188,1.529-0.033,2.365c0,0,2.507,16.642-0.339,24.048
                        L147.643,400.197l0.009,0.004c-8.636,23.11,2.937,48.911,26.014,57.787c23.077,8.875,48.955-2.524,58.03-25.464l0.011,0.005
                        l121.005-314.634c2.366-6.155,15.86-18.079,15.86-18.079c0.677-0.516,1.202-1.108,1.56-1.778l0.059-0.122
                        c0.065-0.132,0.141-0.258,0.193-0.395c3.12-8.113-17.005-23.405-44.952-34.152c-27.948-10.748-53.133-12.884-56.253-4.771
                        c-0.053,0.137-0.083,0.281-0.122,0.422L269.02,59.151z'
        />

        <linearGradient
          id='tube_4_'
          gradientUnits='userSpaceOnUse'
          x1='206.4585'
          y1='215.2629'
          x2='283.1295'
          y2='291.9339'
          gradientTransform='matrix(0.9138 -0.4062 0.4062 0.9138 -80.6459 125.703)'
        >
          <stop offset='0' style={{ stopColor: '#919191' }} />
          <stop offset='1' style={{ stopColor: '#FFFFFF' }} />
        </linearGradient>
        <path
          id='tube_1_'
          fill='url(#tube_4_)'
          d='M265.523,56.477c-0.185,0.737-0.19,1.529-0.033,2.365c0,0,2.508,16.642-0.34,24.048
                        L144.144,397.522l0.011,0.004c-8.635,23.11,2.937,48.911,26.014,57.787c23.075,8.875,48.955-2.524,58.03-25.464l0.011,0.005
                        L349.215,115.22c2.365-6.155,15.86-18.079,15.86-18.079c0.677-0.516,1.202-1.107,1.56-1.778l0.058-0.122
                        c0.065-0.131,0.141-0.258,0.193-0.395c3.12-8.113-17.005-23.404-44.951-34.152c-27.948-10.748-53.133-12.884-56.253-4.771
                        c-0.053,0.137-0.083,0.281-0.122,0.422L265.523,56.477z'
        />

        <linearGradient
          id='liquid_3_'
          gradientUnits='userSpaceOnUse'
          x1='177.6289'
          y1='273.7523'
          x2='224.0456'
          y2='320.1689'
          gradientTransform='matrix(0.9138 -0.4062 0.4062 0.9138 -80.6459 125.703)'
        >
          <stop offset='0' style={{ stopColor: '#990000' }} />
          <stop offset='1' style={{ stopColor: '#E80000' }} />
        </linearGradient>
        <path
          id='liquid_1_'
          fill='url(#liquid_3_)'
          d='M303.48,198.814L216.218,425.71l0.057,0.021
                        c-6.436,16.262-25.166,24.723-41.781,18.333c-16.615-6.39-25.608-25.512-19.488-41.897l0,0l55.758-144.982
                        c0,0,6.964-11.233,20.637-19.225c13.673-7.991,24.949-6.305,40.132-13.053C286.715,218.159,303.48,198.814,303.48,198.814z'
        />

        <ellipse
          id='top_1_'
          transform='matrix(0.9334 0.359 -0.359 0.9334 48.4129 -108.3439)'
          fill={color}
          cx='315.97'
          cy='76.201'
          rx='33.648'
          ry='8.85'
        />
        <path
          id='side-reflection_1_'
          opacity='0.3'
          fill='#FFFFFF'
          d='M265.489,58.841c0,0,2.471,16.737-0.34,24.048L144.144,397.522
                        l0.011,0.004c-8.635,23.11,2.937,48.911,26.014,57.787c4.005,1.54,8.092,2.455,12.164,2.822
                        c-15.556-11.702-22.23-32.632-15.093-51.73l-0.011-0.004L285.833,98.009C285.833,98.009,269.689,82.85,265.489,58.841z'
        />
        <g id='bubbles_1_'>
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='226.531'
            cy='261.806'
            r='3.506'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='249.514'
            cy='287.227'
            r='5.285'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='214.429'
            cy='317.459'
            r='9.915'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='198.375'
            cy='335.795'
            r='5.286'
          />
          <circle
            opacity='0.5'
            fill='#FFFFFF'
            cx='219.43'
            cy='375.008'
            r='3.506'
          />
        </g>
      </g>
    </g>
  </Svg>
)
